<template>
  <Toast />
  <div class="loading-container">
    <img
      class="loading-logo"
      src="~@/assets/logo_tema_escuro.svg"
      alt="Loading"
    />
  </div>
  <div class="content main-login d-flex align-items-center">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <div class="left-login col-lg-9">
            <div class="card-login">
              <img
                class="logo"
                src="~@/assets/logo_tema_escuro.svg"
                alt="AdminLTELogo"
              />
              <h3>Crie sua conta agora, é rapidinho!</h3>

              <div class="textfield mt-3">
                <label for="cpf">CPF</label>
                <input
                  id="cpf"
                  v-model="formData.cpf"
                  type="text"
                  class="form-control"
                  :class="{ invalid: fieldWithError.cpf }"
                  placeholder="Informe seu CPF, apenas números"
                  required
                  @input="formatCPF"
                />
              </div>

              <div class="textfield mt-3">
                <label for="cell_phone">Celular</label>
                <vue-tel-input
                  id="cell_phone"
                  v-model="formData.cell_phone"
                  class="form-select"
                  :class="{ invalid: fieldWithError.cell_phone }"
                  style="background-color: #fff"
                />
              </div>

              <div class="textfield mt-3">
                <label for="email">E-mail</label>
                <input
                  id="email"
                  v-model="formData.email"
                  type="email"
                  class="form-control"
                  :class="{ invalid: fieldWithError.email }"
                  placeholder="Informe seu e-mail"
                  required
                />
              </div>

              <div class="textfield mt-3">
                <label for="name">Nome</label>
                <input
                  id="name"
                  v-model="formData.name"
                  type="text"
                  class="form-control cell_phone"
                  :class="{ invalid: fieldWithError.name }"
                  placeholder="Informe seu nome completo"
                  required
                />
              </div>

              <div class="textfield mt-3">
                <label for="birthDate" class="form-label">
                  Data de nascimento
                </label>
                <input
                  id="birthDate"
                  v-model="formData.birthDate"
                  type="tel"
                  class="form-control"
                  :class="{ invalid: fieldWithError.birthDate }"
                  placeholder="Informe sua data de nascimento"
                  required
                  @input="formatBirthDate"
                />
              </div>

              <div class="textfield mt-3">
                <label for="password">Senha</label>
                <input
                  id="password"
                  v-model="formData.password"
                  type="password"
                  class="form-control"
                  :class="{ invalid: fieldWithError.password }"
                  placeholder="Sua senha com no mínimo 8 caracteres"
                  required
                />
              </div>
              <div class="textfield mt-3">
                <label for="confirmPassword">Confirmação de senha</label>
                <input
                  id="confirmPassword"
                  v-model="formData.confirmPassword"
                  type="password"
                  class="form-control"
                  :class="{ invalid: fieldWithError.confirmPassword }"
                  placeholder="Repita a senha informada acima"
                  required
                />
              </div>

              <input v-model="formData.customer_id" type="hidden" />
              <input v-model="formData.token" type="hidden" />

              <div class="col-auto switch mt-3">
                <div class="form-check">
                  <input
                    id="custom"
                    v-model="confirmTerms"
                    class="form-check-input"
                    type="checkbox"
                    required
                  />
                  <span class="text-white confirm-terms" @click="openModal"
                    >Li e estou de acordo com o
                    <span>Termo de Uso e Política de Privacidade</span></span
                  >
                </div>
              </div>

              <button
                type="button"
                :disabled="loading || !confirmTerms"
                :class="[
                  'btn-login btn-block',
                  loading || !confirmTerms ? 'btn-disabled' : '',
                ]"
                @click="registerUser"
              >
                {{ loading ? "Aguarde..." : "Registrar" }}
              </button>

              <div class="mt-3">
                <router-link to="/login" class="cadastro">
                  Já possuo cadastro
                </router-link>
              </div>

              <div v-if="displayError.status" id="responseMessage" class="mt-3">
                <div class="alert alert-danger">
                  {{ displayError.message }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12" />
      </div>
    </div>
    <Modal terms-and-privacy :is-open="isModalOpen" @close="closeModal">
      <TermsAndPrivacy />
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
import Modal from "../components/shared/Modal.vue";
import TermsAndPrivacy from "../components/user/TermsAndPrivacy.vue";
export default {
  components: {
    Modal,
    TermsAndPrivacy,
  },
  data() {
    return {
      loading: false,
      formData: {
        cpf: "",
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
        cell_phone: "",
        birthDate: "",
        customer_id: "",
        token: "",
        consultant: "",
        alias: "",
      },
      displayError: { status: false, message: "" },
      fieldWithError: {
        cpf: false,
        cell_phone: false,
        email: false,
        name: false,
        birthDate: false,
        password: false,
        confirmPassword: false,
      },
      confirmTerms: false,
      isModalOpen: false,
    };
  },
  created() {
    this.formData.consultant = this.$route.params.consultant || "";
    this.formData.alias = this.$route.params.alias || "";

    setTimeout(() => {
      const loadingContainer = document.querySelector(".loading-container");
      const content = document.querySelector(".content");

      loadingContainer.style.opacity = "0";
      loadingContainer.style.pointerEvents = "none";
      content.style.display = "block";
      this.loadingDone = true; // Set a flag to indicate loading is done
    }, 2000);
  },
  methods: {
    formatCPF() {
      let cpf = this.formData.cpf.replace(/\D/g, "");
      cpf = cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      this.formData.cpf = cpf;
    },
    formatBirthDate() {
      let value = this.formData.birthDate.replace(/\D/g, "").slice(0, 8);
      if (value.length >= 5) {
        value = value.replace(/(\d{2})(\d{2})(\d{1,4})/, "$1/$2/$3");
      } else if (value.length >= 3) {
        value = value.replace(/(\d{2})(\d{1,2})/, "$1/$2");
      }
      this.formData.birthDate = value;
    },
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    async registerUser() {
      const {
        cpf,
        name,
        email,
        password,
        confirmPassword,
        cell_phone,
        birthDate,
        customer_id,
        token,
        consultant,
        alias,
      } = this.formData;

      this.resetErrorMessages();

      if (!cpf || cpf.length < 14) {
        this.fieldWithError.cpf = true;
        this.showErrorMessage("Ooops...", "Informe um CPF válido");
        this.focusInput("cpf");
        return;
      }

      if (cell_phone == "") {
        this.fieldWithError.cell_phone = true;
        this.showErrorMessage("Ooops...", "Informe um telefone válido");
        this.focusInput("cell_phone");
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        this.fieldWithError.email = true;
        this.showErrorMessage("Ooops...", "Informe um e-mail válido");
        this.focusInput("email");
        return;
      }

      if (!name || name.trim().length < 3) {
        this.fieldWithError.name = true;
        this.showErrorMessage("Ooops...", "Informe seu nome completo");
        this.focusInput("name");
        return;
      }

      if (!birthDate) {
        this.fieldWithError.birthDate = true;
        this.showErrorMessage(
          "Ooops...",
          "Informe uma data de nascimento válida"
        );
        this.focusInput("birthDate");
        return;
      }

      const birthDateParts = birthDate.split("/");
      if (birthDateParts.length === 3) {
        const day = parseInt(birthDateParts[0]);
        const month = parseInt(birthDateParts[1]);
        const year = parseInt(birthDateParts[2]);

        const birthDateObj = new Date(year, month - 1, day);
        const today = new Date();

        if (birthDateObj > today) {
          this.fieldWithError.birthDate = true;
          this.showErrorMessage(
            "Ooops...",
            "Informe uma data de nascimento válida"
          );
          this.focusInput("birthDate");
          return;
        }

        const age = this.calculateAge(birthDateObj);
        if (age < 18) {
          this.fieldWithError.birthDate = true;
          this.showErrorMessage(
            "Ooops...",
            "Você deve ter pelo menos 18 anos para criar uma conta"
          );
          this.focusInput("birthDate");
          return;
        }
      }

      if (!password || password.length < 8) {
        this.fieldWithError.password = true;
        this.showErrorMessage(
          "Ooops...",
          "A senha deve ter no mínimo 8 caracteres"
        );
        this.focusInput("password");
        return;
      }

      if (!confirmPassword || password != confirmPassword) {
        this.fieldWithError.confirmPassword = true;
        this.showErrorMessage("Ooops...", "As senhas informadas não conferem");
        this.focusInput("confirmPassword");
        return;
      }

      const cpfDigits = cpf.replace(/\D/g, "");
      const formattedBirthDate = birthDate.split("/").reverse().join("-");
      const payload = {
        cpf: cpfDigits,
        name: name.trim(),
        cell_phone: cell_phone.trim(),
        birth_date: formattedBirthDate,
        email: email.trim(),
        password: password,
        password_confirmation: confirmPassword,
        customer_id: customer_id,
        consultant_id: this.$route.query.code,
        token: token,
        consultant: consultant,
        alias: alias,
      };
      this.loading = true;
      axios
        .post(`/user/register`, payload)
        .then((response) => {
          this.$toast.add({
            severity: "success",
            summary: "Sucesso",
            detail:
              "Sua conta foi criada! Agora, você será redirecionado para realizar o acesso.",
            life: 5000,
          });
          setTimeout(() => {
            this.$router.push("/login");
          }, 2000);
        })
        .catch((error) => {
          if (error.response?.status === 400 && error.response?.data?.errors) {
            let field = undefined;
            if (error.response.data.errors.cpf) {
              field = "CPF";
            } else if (error.response.data.errors.cell_phone) {
              field = "telefone";
            } else if (error.response.data.errors.email) {
              field = "e-mail";
            } else if (error.response.data.errors.birth_date) {
              const birthDateError = error.response.data.errors.birth_date[0];
              if (birthDateError && birthDateError.includes("18")) {
                this.fieldWithError.birthDate = true;
                this.showErrorMessage(
                  "Ooops...",
                  "Você deve ter pelo menos 18 anos para criar uma conta"
                );
                this.focusInput("birthDate");
                return;
              }
            }
            if (field) {
              this.showErrorMessage(
                "Oops...",
                `Já existe uma conta para o ${field} informado. Você será redirecionado para realizar o acesso.`
              );
              setTimeout(() => {
                this.$router.push("/login");
              }, 3000);
              return;
            }
          }
          this.showErrorMessage(
            "Oops...",
            "Ocorreu um erro ao criar sua conta. Entre em contato com o suporte."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showErrorMessage(title, message) {
      this.$toast.add({
        severity: "error",
        summary: title,
        detail: message,
        life: 5000,
      });
    },
    resetErrorMessages() {
      Object.keys(this.fieldWithError).forEach((key) => {
        this.fieldWithError[key] = false;
      });
      console.log(this.fieldWithError);
      this.displayError.status = false;
      this.displayError.message = "";
    },
    focusInput(fieldId) {
      this.$nextTick(() => {
        const inputElement = document.getElementById(fieldId);
        if (inputElement) {
          inputElement.focus();
        }
      });
    },
    calculateAge(birthDate) {
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      return age;
    },
  },
};
</script>

<style lang="scss">
.vti__input {
  background-color: transparent !important;
  color: #000;
}

.vti__input::placeholder {
  color: #828282 !important;
}

.vue-tel-input input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
  -webkit-text-fill-color: #212529 !important;
}
</style>

<style lang="scss" scoped>
body {
  font-family: "Montserrat", sans-serif;
  margin: 0;
}

.main-login {
  background-image: url("~@/assets/background-login.png");
  /* background-image: url("~@/assets/bg-login.jpg"); */
  background-size: cover;
  background-position: center;
  padding: 40px 0;
  min-height: 100vh;
}

.rigth-login {
  padding-top: 40px;
  color: aliceblue;
}
h4 {
  font-size: 20px;
}
.separator {
  width: 100%;
  border: 1px solid #b9b9b9;
  margin: 10px 0;
}
.quote {
  display: flex;
  margin-left: 200px;
}
.quote > span {
  color: #d75413;
  font-size: 100px;
  font-weight: bold;
  margin: 0;
}
.quote > h4 {
  text-align: center;
  font-size: 24px;
  margin: 0;
}

.card-login {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #ffffff10;
  padding: 40px;
  border-radius: 10px;
  border: 2px solid #ffffff30;
  backdrop-filter: blur(10px);
  box-shadow: 0px 10px 40px #00000056;
}

.card-login > img {
  width: 30%;
  height: auto;
  margin-bottom: 30px;
}

.card-login > h3 {
  color: aliceblue;
  font-size: 22px;
  font-weight: 800;
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.card-login > h5 {
  color: aliceblue;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 30px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.textfield {
  width: 100%;
}
a {
  font-size: 14px;
}

.textfield > input {
  width: 100%;
  height: 38px;
  border: 1px solid #b9b9b9;
  border-radius: 5px;
  background: #ffffff;
  font-size: 12pt;
  box-shadow: 0px 10px 40px #00000056;
  outline: none;
  box-sizing: border-box;
}

label {
  color: aliceblue;
  font-size: 14px;
  margin-bottom: 5px;
}

.textfield > input::placeholder {
  color: gray;
}

.checkbox {
  color: aliceblue;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 10px;
}

.btn-login {
  width: 100%;
  height: 38px;
  margin-top: 30px;
  font-size: 14px;
  border: none;
  border-radius: 5px;
  outline: none;
  font-weight: bold;
  letter-spacing: 2px;
  color: aliceblue;
  background: #d75413;
  cursor: pointer;
}

.btn-disabled {
  opacity: 0.5;
}

.cadastro {
  color: aliceblue;
  text-decoration: none;
}
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #181d2f;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  opacity: 1;
  transition: opacity 0.5s ease-in-out; /* Transição suave da opacidade */
  pointer-events: all; /* Permite interação com o loading */
}

.loading-logo {
  width: 100px; /* Largura inicial da logo */
  height: auto;
  animation: pulse 1.5s infinite alternate; /* Animação de pulsação */
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2); /* Aumenta a logo em 20% */
  }
}

.content {
  display: none;
}

.form-check-input:checked {
  background-color: #ff6800;
  border-color: #ff6800;
}

.confirm-terms {
  cursor: pointer;
  span {
    color: #ff6800;

    &:hover {
      color: #ff6800;
    }
  }
}

@media only screen and (max-width: 990px) {
  .main-login {
    background-image: url("~@/assets/bg-login.jpg");
  }
}

.invalid {
  border: 2px solid red !important;
}
</style>
